import { render, staticRenderFns } from "./MiniAssignmentChip.vue?vue&type=template&id=daa078b4&scoped=true&"
import script from "./MiniAssignmentChip.vue?vue&type=script&lang=ts&"
export * from "./MiniAssignmentChip.vue?vue&type=script&lang=ts&"
import style0 from "./MiniAssignmentChip.vue?vue&type=style&index=0&id=daa078b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa078b4",
  null
  
)

export default component.exports